export default {
    toolbar: {
        items: [
            'heading',
            'horizontalLine',
            '|',
            'link',
            'linkBrowser',
            '|',
            'bold',
            'italic',
            'alignment',
            'subscript',
            'superscript',
            'underline',
            'strikethrough',
            '|',
            'blockQuote',
            'bulletedList',
            'numberedList',
            '|',
            'insertTable',
            'mediaBrowser',
            'mediaEmbed',
            '|',
            'snippetBrowser',
            'htmlEmbed',
            '|',
            'undo',
            'redo'
        ]
    },
}
